const initialState = {
  googleFonts: [],
  customFontsList: [],
  globalTheme: [],
  installMultiTenantPluginPending: false,
  installMultiTenantPluginError: null,
  getGoogleFontsPending: false,
  getGoogleFontsError: null,
  addCustomFontsInProjectPending: false,
  addCustomFontsInProjectError: null,
  getCustomFontsPending: false,
  getCustomFontsError: null,
  deleteCustomFontPending: false,
  deleteCustomFontError: null,
  addGlobalThemesPending: false,
  addGlobalThemesError: null,
  getGlobalThemePending: false,
  getGlobalThemeError: null,
};

export default initialState;
